export const GET_CURRENT_EQUIPMENT = 'GET_CURRENT_EQUIPMENT';


